import { nsBeneficiaries } from '@/app/i18n/namespaces';
import PropTypes from 'prop-types';
import Entity from '@/common-utils/components/renders/entity/Entity';


/**
 *
 * @param {string} color
 * @param {string} name
 * @param {array} contracts
 * @param {string} displayVariant
 * @returns {JSX} BeneficiarySummary
 */
function BeneficiarySummary({ color, name, contracts, displayVariant = 'default' }) {
    const isCompact = displayVariant === 'tpe';

    return (
        <div className={`flex items-center gap-2 ${isCompact ? 'text-sm' : ''}`}>
            <span
                className={`${isCompact ? 'w-4 h-4' : 'w-5 h-5'} rounded-full shrink-0 border border-dark-foreground`}
                style={{ backgroundColor: color }}
            />
            <span className={isCompact ? 'text-sm' : ''}>
                <span className='font-semibold opacity-[.8]'>{name}</span>
                {' '}
                <span className='text-muted-foreground font-normal'>
                    ({contracts.length}{' '}
                    <Entity
                        entity='actions.beneficiary.contracts_count'
                        namespace={nsBeneficiaries}
                        data={{ count: contracts.length }}
                    />)
                </span>
            </span>
        </div>
    );
}

BeneficiarySummary.propTypes = {
    color: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    contracts: PropTypes.array.isRequired,
    displayVariant: PropTypes.oneOf(['default', 'tpe'])
};

export default BeneficiarySummary;